import { Button } from "antd";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx-js-style";

const FILE_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const FILE_EXTENSION = ".xlsx";

// Construye y da formato a la hoja de Excel a partir de un Array de objetos (filas).
function buildWorksheet(data) {
  const ws = XLSX.utils.json_to_sheet(data);

  // Estilizar la fila de cabecera (fila 1)
  Object.entries(ws).forEach(([key, cell]) => {
    if (/[A-Z]+1$/.test(key)) {
      cell.s = {
        fill: { bgColor: { rgb: "252527" }, fgColor: { rgb: "252527" } },
        font: { bold: true, color: { rgb: "FFFFFF" } },
      };
    }
  });

  // Ajustar el ancho de cada columna al contenido más largo
  const colWidths = {};
  Object.keys(ws).forEach(key => {
    if (key.startsWith('!')) return;
    const colLetter = key.replace(/[0-9]/g, '');
    const colIndex = colLetter.charCodeAt(0) - 65;
    const cellWidth = String(ws[key].v).length + 2;
    if (!colWidths[colIndex] || cellWidth > colWidths[colIndex]) {
      colWidths[colIndex] = cellWidth;
    }
  });

  ws['!cols'] = Object.values(colWidths).map(w => ({ wch: w }));
  return ws;
}

// MOTOR ÚNICO DE EXPORTACIÓN A EXCEL //
//------------------------------------//
// sheets = Array<{ name, data }> (una entrada por hoja). 
//    name = nombre de la hoja
//    data = Array<{ [key]: value }> (filas de la hoja).
// fileName = nombre del archivo (sin extensión).
export async function downloadExcel(sheets, fileName) {
  const wb = {
    SheetNames: sheets.map(s => s.name),
    Sheets: Object.fromEntries(sheets.map(s => [s.name, buildWorksheet(s.data)])),
  };
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { file: FILE_TYPE });
  FileSaver.saveAs(blob, fileName + FILE_EXTENSION);
}

// COMPONENTE = capa UI sobre el motor.
// fileData resuelve SIEMPRE a Array<{ name, data }>. Mismo formato que recive el motor. 
// Puede ser un Array o una función que devuelva un Array o una Promise de Array.
const ExportExcel = ({ fileName, fileData, label, disabled = false }) => {

  const exportToExcel = async () => {
    try {
      let sheets = typeof fileData === 'function' ? fileData() : fileData;
      if (sheets instanceof Promise) sheets = await sheets;

      if (!sheets) return;

      await downloadExcel(sheets, fileName);
    } catch (err) {
      console.error('Error al exportar a Excel: ' + err);
    }
  };

  return (
    <Button
      variant="contained"
      disabled={disabled}
      onClick={exportToExcel}
    >
      {label}
    </Button>
  );
};

export default ExportExcel;
